import React, { useState } from 'react';
import CancelWarningPopup from './CancelWarningPopup';
import '../../../styles/phrase-training.css';

const NonProsodicModal = ({ visible, onSubmit, onCancel }) => {
    const [showCancelConfirm, setShowCancelConfirm] = useState(false);
    const defaultNonManuals = {
        eyebrows: 'N/A',
        head: 'N/A',
        mouth: 'N/A',
        eyes: 'N/A',
        nose: 'N/A',
        shoulders: 'N/A',
    };

    if (!visible) return null;

    return (
        <div className="phrase-modal-overlay">
            <div className="phrase-modal">
                <h3 className="phrase-modal-title">Emotion Scoring</h3>
                <p className="emotion-warning">
                    <img
                        src="/icons/caution.svg"
                        alt="Warning"
                        className="warning-icon"
                    />
                    WARNING: If you leave the page before submitting, your video will be deleted.
                </p>
                <p>This variation was non-prosodic. No need to score this one! 😊</p>
                <div className="phrase-modal-buttons">
                    <button
                        className="phrase-button secondary"
                        onClick={() => setShowCancelConfirm(true)}
                    >
                        Cancel/Retry
                    </button>
                    <button
                        className="phrase-button primary"
                        onClick={() =>
                            onSubmit({
                                non_manuals: defaultNonManuals,
                                notes: '',
                            })
                        }
                    >
                        Submit
                    </button>
                </div>
            </div>
            {showCancelConfirm && (
                <CancelWarningPopup
                    message="Canceling will delete this recording. Are you sure?"
                    onConfirm={() => {
                        setShowCancelConfirm(false);
                        onCancel();
                    }}
                    onClose={() => setShowCancelConfirm(false)}
                />
            )}
        </div>
    );
};

export default NonProsodicModal;

